export const SAVE = 'stepPaymentDetails.SAVE';
export const VALUE_CHANGED = 'stepPaymentDetails.VALUE_CHANGED';
export const LOAD = 'stepPaymentDetails.VALUE_LOAD';
export const NEXT = 'stepPaymentDetails.NEXT';
export const RESET = 'stepPaymentDetails.RESET';
export const RESET_ADDRESS = 'stepPaymentDetails.RESET_ADDRESS';
export const RESET_REGISTER_GST_STATE = 'stepPaymentDetails.RESET_REGISTER_GST_STATE';
export const CLOSE_BSB_NOTICE = 'stepPaymentDetails.CLOSE_BSB_NOTICE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPaymentDetails/constants.js